import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { CloudImage } from '@components/CloudImage';
import { TextPairing } from '@components/TextPairing';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { Text } from '@components/typography';
import { VideoPlayer } from '@components/VideoPlayer';

export const skewHWRatio = 0.3;

export const DownButtonWrapper = styled(Flex)`
  position: relative;
  z-index: 1;
  justify-content: space-between;
`;
export const StyledMobileSection = styled(Box)`
  position: relative;
  width: 100vw;
`;

export const MainBackgroundImage = styled(Flex)<{
  backgroundImage: string;
}>`
  background: url(${props => cloudAssetUrl(props.backgroundImage)});
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  width: 100%;
  height: 1200px;
  display: flex;
  justify-content: center;
  margin-top: -5px;
  ${themeMediaQuery('below_sm')} {
    height: 900px;
    margin-top: -100px;
    z-index: -1;
  }
  ${themeMediaQuery('sm')} {
    height: 1200px;
    margin-top: -5px;
  }
  ${themeMediaQuery('xl')} {
    height: 1400px;
  }
  @media (min-width: 550px) and (max-width: 830px) {
    margin-top: -20px;
    z-index: -1;
  }
`;

export const StyledBlogWrapper = styled(Flex)`
  position: relative;
`;

export const StyledBlogShape = styled(Flex)`
  position: absolute;
  width: 100%;
  height: max-content;
  z-index: 2;
  top: 400px;
  ${themeMediaQuery('below_sm')} {
    bottom: 0px;
    position: unset;
    min-height: 600px;
    margin-top: -100px;
  }
  ${themeMediaQuery('sm')} {
    top: 250px;
    transform: scale(0.8);
  }
  ${themeMediaQuery('md')} {
    top: 200px;
    transform: scale(1);
  }
  ${themeMediaQuery('lg')} {
    top: 250px;
  }
  ${themeMediaQuery('xl')} {
    /* top: 400px; */
    top: 200px;
  }
  @media (min-width: 550px) and (max-width: 830px) {
    top: 500px;
    position: absolute;
    min-height: 500px;
  }
`;

export const BlogCenterTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 555px;
  }
  .text-pairing-body {
    max-width: 445px;
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 730px;
    }
    .text-pairing-body {
      max-width: 530px;
    }
  }
`;

export const PaymentLogo = styled(CloudImage)`
  object-fit: contain;
  width: 100px;
  height: 20px;
  ${themeMediaQuery('below_sm')} {
    width: 60px;
    height: 20px;
  }
`;

export const BottomWaveImage = styled(CloudImage)`
  object-fit: cover;
  z-index: 9;
  position: absolute;
  ${themeMediaQuery('below_sm')} {
    bottom: -10px;
    width: 100%;
  }
  ${themeMediaQuery('sm')} {
    bottom: -10px;
    width: 100%;
  }
  ${themeMediaQuery('md')} {
    bottom: -100px;
    width: 110%;
  }
`;

export const StyledVideo = styled(VideoPlayer)`
  width: 120%;
  transform: translateX(-10%);
  height: inherit;
  object-fit: cover;
  object-position: center bottom;
  ${themeMediaQuery('below_sm')} {
    height: 400px;
  }
  ${themeMediaQuery('sm')} {
    width: 140%;
    transform: translateX(-20%);
  }
  ${themeMediaQuery('md')} {
    width: 120%;
    transform: translateX(-10%);
  }
  ${themeMediaQuery('xl')} {
    width: 100%;
    transform: translateX(0);
  }
  @media (min-width: 550px) and (max-width: 830px) {
    height: 750px;
  }
`;

export const StyledVideoWrapper = styled(Box)`
  width: 100%;
  height: 700px;
  ${themeMediaQuery('below_sm')} {
    height: max-content;
  }
  ${themeMediaQuery('lg')} {
    height: 800px;
  }
  ${themeMediaQuery('xl')} {
    height: 900px;
  }
`;

export const BlogShape1Mobile = styled(CloudImage)`
  width: 100%;
  height: 700px;
  top: 24px;
  left: -45px;
  position: absolute;
  @media (min-width: 550px) and (max-width: 830px) {
    height: 500px;
    left: -35px;
  }
`;

export const BlogShape2Mobile = styled(Flex)<{
  backgroundImage: string;
}>`
  background: url(${props => cloudAssetUrl(props.backgroundImage)});
  background-repeat: no-repeat;
  background-position: top;
  background-size: contain;
  /* width: 800px;
  height: 600px; */
  width: 1024px;
  height: 768px;
  @media (min-width: 550px) and (max-width: 830px) {
    height: 500px;
  }
`;

export const LogosFlex = styled(Flex)`
  > *:not(:first-child) {
    margin-left: ${themeSpace(8)};
  }
`;

export const Fee2LogosWrapper = styled(Flex)`
  height: 187px;
  opacity: 0.9;
  border-radius: 27px;
  ${themeMediaQuery('below_sm')} {
    width: 95%;
    justify-content: space-around;
    height: 100px;
  }
  ${themeMediaQuery('sm')} {
    transform: scale(0.8);
  }
  ${themeMediaQuery('md')} {
    transform: scale(1);
  }
`;

export const Fee2LogosWrapperAndTextWrapper = styled(Flex)`
  width: 100%;
  @media (max-width: 320px) {
    margin-top: ${themeSpace(14)};
  }
  ${themeMediaQuery('sm')} {
    margin-top: 20rem;
  }
  @media (min-width: 550px) and (max-width: 830px) {
    margin-top: 15rem;
  }
  @media (min-width: 1400px) {
    margin-top: 25rem;
  }
  ${themeMediaQuery('lg')} {
    margin-top: 25rem;
  }
  ${themeMediaQuery('xl')} {
    margin-top: 15rem;
  }
`;

export const Fee2LogoImageWrapper = styled(Flex)`
  width: 187px;
  border: 1px solid #ffffff;
  position: relative;
  border-radius: 27px;
  ${themeMediaQuery('below_sm')} {
    width: 50px;
  }
`;

export const ShadowBox = styled(Flex)`
  background: #ffffff;
  box-shadow: 0px 11.28px 30.4561px -5.64002px rgba(68, 50, 93, 0.25), 0px 7.89603px 18.0481px -9.02403px rgba(0, 0, 0, 0.3);
  border-radius: 30.8311px;
  position: absolute;
  width: 211px;
  height: 236.05px;
  ${themeMediaQuery('below_sm')} {
    max-width: 70px;
    height: 120px;
  }
  @media (max-width: 1024px) and (min-width: 768px) {
    max-width: 90px;
    height: 140px;
  }
`;

export const Fee2CloudImage = styled(CloudImage)`
  ${themeMediaQuery('below_sm')} {
    max-width: 50px;
  }
  @media (max-width: 1024px) and (min-width: 768px) {
    max-width: 70px;
  }
`;

export const StyledBox = styled(Flex)`
  flex-direction: column;
  ${themeMediaQuery('below_sm')} {
    width: 90vw;
  }
  ${themeMediaQuery('sm')} {
    width: max-content;
  }
`;

export const StyledFee2Text = styled(Text)`
  ${themeMediaQuery('below_sm')} {
    max-width: 280px;
  }
  @media (max-width: 1024px) and (min-width: 768px) {
    max-width: 90%;
  }
`;

export const StyledLogoText = styled(Text)``;
